import strftime from 'strftime'
import Vue from 'vue'

let LOCALE = null
let TIME_FORMAT = null

function _thisYear(date) {
  if (typeof date !== "object") return false
  const today = new Date();
  return date.getFullYear() === today.getFullYear()
}

function _isToday(date) {
  const today = new Date()
  return date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
}

function _is24hours() {
  return TIME_FORMAT === "24h"
}

function _getDateFormats() {
  return LOCALE.date.formats
}

function _getTimeFormats() {
  return LOCALE.time.formats
}

function _getFormatter () {
  const dateFormats = LOCALE.date
  const timeFormats = LOCALE.time
  const locale = {
    ...timeFormats,
    days: dateFormats.day_names,
    shortDays: dateFormats.abbr_day_names,
    months: dateFormats.month_names.filter(mo => !!mo),
    shortMonths: dateFormats.abbr_month_names.filter(mo => !!mo),
  }

  return strftime.localize(locale)
}

const init = (locale, time_format) => {
  LOCALE = locale
  TIME_FORMAT = time_format
}

/**
* @name  time_today_or_date
* @param {String} dateIso - date as iso format
* @param {Object} options - short: true/false
*
* @return
* Today         - 10:00 pm
* This year     - Jul 8
* Not this year - Jul 8, 2012
*
* Note: am/pm depends on the business configuration
*/
const time_today_or_date = (dateIso, options = {}) => {
  const dateFormats = _getDateFormats()
  const timeFormats = _getTimeFormats()
  const formatter = _getFormatter()
  const date = new Date(dateIso)

  let format;
  if (_isToday(date)) {
    format = _is24hours() ? timeFormats.today_24h : timeFormats.today_12h
  } else if (_thisYear(date)) {
    format = dateFormats.month_without_year
  } else {
    format = options.short ? timeFormats.short : dateFormats.month_with_year
  }

  return formatter(format, date)
}

Vue.filter('time_today_or_date', time_today_or_date)

/**
* @name  date_no_current_year
* @param {String} dateIso - date as iso format
*
* @return
* example input: 2020-11-09T18:11:41.000+02:00
* This year     - Jul 8
* Not this year - Jul 8, 2012
*/
const date_no_current_year = (dateIso) => {
  const formatter = _getFormatter()
  const dateFormats = _getDateFormats()
  const date = new Date(dateIso)
  const format = _thisYear(date) ? dateFormats.month_without_year : dateFormats.month_with_year
  return formatter(format, date)
}

Vue.filter('date_no_current_year', date_no_current_year)

/**
* @name  time_at
* @param {String} dateIso - date as iso format
*
* @return
* example input: 2020-11-09T18:11:41.000+02:00
* output: Mon, November 09 at 6:11pm
* Note: am/pm depends on the business configuration
*/
const time_at = (dateIso) => {
  const formatter = _getFormatter()
  const timeFormats = _getTimeFormats()
  const date = new Date(dateIso)
  let format;
  if (_thisYear(date)) {
    format = _is24hours() ? timeFormats.at_without_year_24h : timeFormats.at_without_year_12h
  } else {
    format = _is24hours() ? timeFormats.at_with_year_24h : timeFormats.at_with_year_12h
  }

  return formatter(format, date)
}

Vue.filter('time_at', time_at)

/**
 * @name  date_and_hour
 * @param {String} dateIso - date as iso format
 *
 * @return
 * example input: 2020-11-09T18:11:41.000+02:00
 * output this year: Nov 09, 6:11pm
 * output last year: Nov 09, 2020, 6:11pm
 * Note: am/pm depends on the business configuration
 */
const date_and_hour = (dateIso) => {
  const formatter = _getFormatter()
  const timeFormats = _getTimeFormats()
  const date = new Date(dateIso)
  let format;
  if (_thisYear(date)) {
    format = _is24hours() ? timeFormats.month_without_year_24h : timeFormats.month_without_year_12h
  } else {
    format = _is24hours() ? timeFormats.month_with_year_24h : timeFormats.month_with_year_12h
  }
  return formatter(format, date)
}

Vue.filter('date_and_hour', date_and_hour)

/**
* @name  time
* @param {String} dateIso - date as iso format
*
* @return
* example input: 2020-11-09T18:11:41.000+02:00
* output: 6:11 pm
* Note: am/pm depends on the business configuration
*/
const time = (dateIso) => {
  const formatter = _getFormatter()
  const timeFormats = _getTimeFormats()
  const format = _is24hours() ? timeFormats.today_24h :timeFormats.today_12h
  const date = new Date(dateIso)
  return formatter(format, date)
}
Vue.filter('time', time)

export default {
  init,
  time_today_or_date,
  date_no_current_year,
  time_at,
  time,
  date_and_hour,
}
